import * as React from 'react';
import { Field } from 'redux-form';

import Input from 'af-fields/Input';

import WorkRequestUpsertFM from '../../../formModel';
import { formSectionClassColumn2, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

const AdditionalBillingInformation: React.FC = () => {
	return (
		<>
			<div className={styles['work-request-form__billing-information-title']}>
				Billing Information
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billTo"
						label="Bill To"
						name={WorkRequestUpsertFM.getAttributeName('billTo')}
						placeholder="Enter Bill To"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToAddress"
						label="Address"
						name={WorkRequestUpsertFM.getAttributeName('billToAddress')}
						placeholder="Enter Address"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToCityStateZip"
						label="City, State, Zip"
						name={WorkRequestUpsertFM.getAttributeName('billToCityStateZip')}
						placeholder="Enter City, State, Zip"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToContactName"
						label="Contact Name"
						name={WorkRequestUpsertFM.getAttributeName('billToContactName')}
						placeholder="Enter Contact Name"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToPhoneNumber"
						label="Phone Number"
						name={WorkRequestUpsertFM.getAttributeName('billToPhoneNumber')}
						placeholder="Enter Phone Number"
						type="tel"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToFaxNumber"
						label="Fax Number"
						name={WorkRequestUpsertFM.getAttributeName('billToFaxNumber')}
						placeholder="Enter Fax Number"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						id="billToEmail"
						label="Email Address"
						name={WorkRequestUpsertFM.getAttributeName('billToEmail')}
						placeholder="Enter Email Address"
					/>
				</div>
			</div>
		</>
	);
};

export default React.memo(AdditionalBillingInformation);
